/* Qapary · carrito: drawer y página, cantidades, cupón, regalo, agregar rápido */
(function () {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const rutas = window.qapary.rutas;

  // La página del carrito se vuelve a dibujar con la Section Rendering API: sin recargar y sin perder la posición.
  const idPagina = () => { const f = q('.carrito-pagina'); const s = f && f.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '') : ''; };
  // Estado de carga de los botones de agregar (sugerencias, tarjetas y empujón): el mismo en todos.
  const cargando = (b, si) => { b.classList.toggle('boton--cargando', si); b.disabled = si; if (si) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); };

  // Aceptación de términos y privacidad antes de pagar (plan Grow: el checkout no admite casillas propias).
  // Se guarda como atributo del carrito, así llega al pedido. "Pagar" lleva aria-disabled y este JS lo bloquea hasta marcarla.
  const ACEPTA = 'Acepta términos y política de cambios';
  // Sobre S/ 700 la sección dibuja el campo de DNI (SUNAT pide identificar al comprador en la boleta).
  // Sin campo en pantalla no se pide nada; con campo, "Pagar" espera un DNI de 8 dígitos ya guardado.
  const DNI = 'DNI';
  const dniValido = (v) => /^[0-9]{8}$/.test(v);
  const dni = {
    guardado: (q('[data-dni-input]') || {}).value || '',
    guardando: null,
    temporizador: null,
    pide() { return !!q('[data-dni-input]'); },
    listo() { return !this.pide() || (dniValido(this.guardado) && !this.guardando); },
    redibujado() { const i = q('[data-dni-input]'); if (i && !this.guardando) this.guardado = i.value; },
    escribir(valor, origen) {
      const limpio = valor.replace(/[^0-9]/g, '').slice(0, 8);
      qa('[data-dni-input]').forEach((i) => { if (i !== origen || i.value !== limpio) i.value = limpio; });
      if (dniValido(limpio)) {
        qa('[data-dni-error]').forEach((p) => { p.hidden = true; });
        qa('[data-dni-input]').forEach((i) => i.removeAttribute('aria-invalid'));
      }
      clearTimeout(this.temporizador);
      this.temporizador = setTimeout(() => this.guardar(limpio), 350);
      acepta.pintar();
    },
    guardar(valor) {
      if (valor === this.guardado && !this.guardando) return Promise.resolve();
      const guardado = fetch(`${rutas.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { [DNI]: valor } }) })
        .then((r) => { if (!r.ok) throw new Error(); this.guardado = valor; })
        .catch(() => window.qapary.toast('No pudimos guardar tu DNI. Intenta de nuevo.', { tono: 'error' }));
      this.guardando = guardado;
      guardado.finally(() => { if (this.guardando === guardado) this.guardando = null; acepta.pintar(); });
      return guardado;
    },
    // Si quedó un guardado pendiente por el temporizador, se dispara ya.
    vaciar() { clearTimeout(this.temporizador); const i = q('[data-dni-input]'); return i ? this.guardar(i.value) : Promise.resolve(); },
  };
  const acepta = {
    si: !!q('[data-acepta-check]:checked'),
    guardando: null,
    // Drawer y página muestran el mismo estado. Tras un redibujo, el servidor manda el estado guardado en el carrito (salvo que haya un guardado en curso).
    redibujado() { const c = q('[data-acepta-check]'); if (c && !this.guardando) this.si = c.checked; dni.redibujado(); this.pintar(); },
    pintar() {
      qa('[data-acepta-check]').forEach((c) => { c.checked = this.si; });
      const listo = this.si && dni.listo();
      qa('[data-checkout]').forEach((a) => { if (listo) a.removeAttribute('aria-disabled'); else a.setAttribute('aria-disabled', 'true'); });
      if (this.si) {
        qa('[data-acepta-error]').forEach((p) => { p.hidden = true; });
        qa('[data-acepta-check]').forEach((c) => c.removeAttribute('aria-invalid'));
      }
    },
    cambiar(si) {
      this.si = si; this.pintar();
      const guardado = fetch(`${rutas.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { [ACEPTA]: si ? 'Sí' : '' } }) })
        .then((r) => { if (!r.ok) throw new Error(); })
        .catch(() => { this.si = !si; this.pintar(); window.qapary.toast('No pudimos guardar tu aceptación. Intenta de nuevo.', { tono: 'error' }); });
      this.guardando = guardado;
      guardado.finally(() => { if (this.guardando === guardado) this.guardando = null; });
      return guardado;
    },
  };
  document.addEventListener('change', (e) => { const c = e.target.closest('[data-acepta-check]'); if (c) acepta.cambiar(c.checked); });
  document.addEventListener('input', (e) => { const i = e.target.closest('[data-dni-input]'); if (i) dni.escribir(i.value, i); });
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-checkout]'); if (!a) return;
    const contenedor = a.parentElement;
    const campoDni = contenedor && q('[data-dni]', contenedor);
    const inputDni = campoDni && q('[data-dni-input]', campoDni);
    // DNI escrito completo con el guardado aún pendiente: se guarda y se sigue al pago.
    if (inputDni && dniValido(inputDni.value) && acepta.si && !dni.listo()) {
      e.preventDefault();
      dni.vaciar().then(() => { if (dni.listo() && acepta.si) location.href = a.href; });
      return;
    }
    if (a.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      // Se marca cada requisito que falta y el foco va al primero, en el orden en que aparecen.
      let primero = null;
      if (inputDni && !dniValido(inputDni.value)) {
        const error = q('[data-dni-error]', campoDni); if (error) error.hidden = false;
        inputDni.setAttribute('aria-invalid', 'true'); primero = inputDni;
      }
      if (!acepta.si) {
        const caja = contenedor && q('[data-acepta]', contenedor);
        const error = caja && q('[data-acepta-error]', caja);
        if (error) error.hidden = false;
        const check = caja && q('[data-acepta-check]', caja);
        if (check) { check.setAttribute('aria-invalid', 'true'); primero = primero || check; }
      }
      if (primero) primero.focus();
      return;
    }
    // Si un atributo todavía se está guardando, se espera para que llegue al checkout.
    const pendientes = [acepta.guardando, dni.guardando].filter(Boolean);
    if (pendientes.length) { e.preventDefault(); Promise.all(pendientes).then(() => { if (acepta.si && dni.listo()) location.href = a.href; }); }
  });
  const carrito = {
    seccionesPedidas() { const id = idPagina(); return id ? `cart-drawer,${id}` : 'cart-drawer'; },
    pintarPagina(data) {
      const id = idPagina(); const html = id && data.sections && data.sections[id];
      if (!html) return false;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nueva = q('.carrito-pagina', doc); const actual = q('.carrito-pagina');
      if (!nueva || !actual) return false;
      actual.innerHTML = nueva.innerHTML;
      this.enlazar(actual);
      // reemplazar() también repinta las promesas; sin drawer se repintan aquí.
      if (data.sections['cart-drawer']) this.reemplazar(data.sections['cart-drawer']);
      else { this.actualizarContador(); if (window.qapary.pintarPromesas) window.qapary.pintarPromesas(); }
      acepta.redibujado();
      return true;
    },
    // Tras sumar en la página: aviso con el total y foco en el título (la región del aviso no se redibuja).
    tras(texto) {
      this.anunciar(`${texto} Total ${this.totalPagina()}.`);
      const titulo = q('.carrito-pagina__titulo'); if (!titulo) return;
      titulo.setAttribute('tabindex', '-1');
      // Si el título quedó fuera de la vista (por ejemplo al llenar el carrito vacío desde abajo), se lleva a la vista con el foco.
      const r = titulo.getBoundingClientRect(); const fuera = r.top < 0 || r.bottom > window.innerHeight;
      titulo.focus({ preventScroll: !fuera });
      if (fuera) titulo.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    },
    // Para lo que no pasa por cart/add ni cart/change (cupón, empujón): pide la sección y la redibuja.
    async refrescarPagina() {
      const id = idPagina(); if (!id) { location.reload(); return; }
      const res = await fetch(`${location.pathname}?sections=${id},cart-drawer`, { headers: { Accept: 'application/json' } });
      const sections = await res.json();
      if (!this.pintarPagina({ sections })) location.reload();
    },
    // Aviso para lector de pantalla en la página (la región vive fuera de lo que se redibuja).
    anunciar(texto) {
      let r = q('#carrito-anuncio');
      if (!r) { r = document.createElement('p'); r.id = 'carrito-anuncio'; r.className = 'visualmente-oculto'; r.setAttribute('role', 'status'); document.body.appendChild(r); }
      r.textContent = ''; setTimeout(() => { r.textContent = texto; }, 60);
    },
    totalPagina() { const t = q('.resumen__total .h3:last-child'); return t ? t.textContent.trim() : ''; },
    async refrescar() {
      const res = await fetch(`${rutas.root}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      this.reemplazar(data['cart-drawer']);
    },
    reemplazar(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nuevo = q('[data-carrito-drawer]', doc);
      const actual = q('[data-carrito-drawer]');
      if (!nuevo || !actual) return;
      const abierto = actual.hasAttribute('open');
      q('[data-carrito-cuerpo]', actual).innerHTML = q('[data-carrito-cuerpo]', nuevo).innerHTML;
      q('[data-carrito-titulo]', actual).textContent = q('[data-carrito-titulo]', nuevo).textContent;
      if (abierto) { actual.hidden = false; }
      if (window.qapary.pintarPromesas) window.qapary.pintarPromesas();
      if (window.qapary.marcarEnCarrito) window.qapary.marcarEnCarrito();
      this.actualizarContador(doc);
      this.enlazar(actual);
      acepta.redibujado();
    },
    actualizarContador(doc) {
      fetch(`${rutas.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => {
        qa('[data-carrito-contador]').forEach((el) => { el.textContent = c.item_count; if ('hidden' in el) el.hidden = c.item_count === 0; });
        qa('[data-carrito-parentesis]').forEach((el) => { el.hidden = c.item_count === 0; }); // menú móvil: sin "Carrito ()" con 0
        // En escritorio el header dice "Carrito (N)" en texto: también se actualiza, con su nombre accesible.
        qa('[data-carrito-enlace]').forEach((a) => {
          const t = q('.header__accion-texto', a);
          const tr = window.qapary.t || {};
          if (t) t.textContent = (tr.carrito || 'Carrito') + (c.item_count > 0 ? ` (${c.item_count})` : '');
          const plantilla = c.item_count === 1 ? tr.carrito_uno : tr.carrito_otros; // accesibilidad.carrito_con, con su plural
          if (plantilla) a.setAttribute('aria-label', plantilla.replace('__N__', c.item_count));
        });
      }).catch(() => {});
    },
    async cambiar(key, cantidad, contenedor) {
      contenedor.classList.add('carrito--cargando');
      const enPagina = !!(contenedor.closest && contenedor.closest('.carrito-pagina'));
      const activo = document.activeElement;
      const etiqueta = activo && activo.closest('[data-linea]') ? activo.getAttribute('aria-label') : null;
      try {
        const res = await fetch(`${rutas.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: cantidad, sections: this.seccionesPedidas() }) });
        const data = await res.json();
        if (!res.ok) { window.qapary.toast(data.description || data.message || 'No se pudo actualizar', { tono: 'error' }); return; }
        if (q('[data-carrito-pagina]')) { if (!this.pintarPagina(data)) { location.reload(); return; } }
        else this.reemplazar(data.sections['cart-drawer']);
        // Drawer o página: el foco vuelve al mismo control de la misma línea; si quedó deshabilitado (por ejemplo "Una menos" en 1
        // o "Una más" en el tope), al campo de cantidad; si la línea se quitó, al título.
        const raiz = enPagina ? q('.carrito-pagina') : q('[data-carrito-drawer]');
        const linea = raiz && q(`[data-linea][data-key="${CSS.escape(key)}"]`, raiz);
        let destino = linea && etiqueta ? qa('[aria-label]', linea).find((el) => el.getAttribute('aria-label') === etiqueta && !el.disabled) : null;
        if (!destino && linea) destino = q('[data-linea-input]', linea);
        if (!destino && raiz) { destino = q(enPagina ? '.carrito-pagina__titulo' : '[data-carrito-titulo]', raiz); if (destino) destino.setAttribute('tabindex', '-1'); }
        if (destino) destino.focus({ preventScroll: true });
        const total = enPagina ? this.totalPagina() : ((q('[data-carrito-drawer] .carrito__subtotal .precio') || {}).textContent || '').trim();
        const tope = linea && q('[data-linea-tope]', linea);
        const texto = !total ? 'Tu carrito quedó vacío.' : `${cantidad === 0 ? 'Quitaste la pijama.' : 'Cantidad actualizada.'}${tope ? ` ${tope.textContent.trim()}.` : ''} Total ${total}.`;
        if (enPagina) this.anunciar(texto);
        else { const estado = q('[data-carrito-estado]'); if (estado) { estado.textContent = ''; setTimeout(() => { estado.textContent = texto; }, 60); } } // vaciar antes: un texto igual se vuelve a leer
      } catch (e) { window.qapary.toast('Sin conexión. Intenta de nuevo.', { tono: 'error' }); }
      finally { contenedor.classList.remove('carrito--cargando'); }
    },
    async agregar(variantId, cantidad = 1, propiedades) {
      const cuerpo = { id: variantId, quantity: cantidad, sections: this.seccionesPedidas() };
      if (propiedades) cuerpo.properties = propiedades;
      const res = await fetch(`${rutas.cart_add}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
      return data;
    },
    async cupon(codigo, form) {
      const error = q('[data-cupon-error]', form.closest('[data-cupon]'));
      error.hidden = true;
      const boton = q('button', form); boton.classList.add('boton--cargando');
      try {
        const res = await fetch(`${rutas.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codigo }) });
        const data = await res.json();
        const aplicado = (data.discount_codes || []).find((d) => d.code.toLowerCase() === codigo.toLowerCase());
        if (!aplicado || !aplicado.applicable) {
          q('span', error).textContent = `El cupón ${codigo} no aplica a este carrito. Revisa la escritura o las condiciones.`;
          error.hidden = false;
          await fetch(`${rutas.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(() => {});
          return;
        }
        if (q('[data-carrito-pagina]')) { await this.refrescarPagina(); window.qapary.toast(`Cupón ${codigo} aplicado`); return; }
        await this.refrescar();
        window.qapary.toast(`Cupón ${codigo} aplicado`);
      } catch (e) { q('span', error).textContent = 'No pudimos validar el cupón. Intenta de nuevo.'; error.hidden = false; }
      finally { boton.classList.remove('boton--cargando'); }
    },
    enlazar(raiz) {
      qa('[data-linea]', raiz).forEach((linea) => {
        qa('[data-linea-cantidad]', linea).forEach((b) => b.addEventListener('click', () => this.cambiar(linea.dataset.key, Number(b.dataset.lineaCantidad), raiz)));
        const input = q('[data-linea-input]', linea);
        // Escribir más de lo que hay no pide lo imposible: se queda en el tope de esa talla.
        if (input) input.addEventListener('change', () => { const max = Number(input.max) || Infinity; const v = Math.min(max, Math.max(0, Number(input.value) || 0)); input.value = v; this.cambiar(linea.dataset.key, v, raiz); });
      });
      const cuponForm = q('[data-cupon-form]', raiz);
      if (cuponForm) cuponForm.addEventListener('submit', (e) => { e.preventDefault(); const c = q('[data-cupon-input]', cuponForm).value.trim(); if (c) this.cupon(c, cuponForm); });

      // Regalo: la casilla y la dedicatoria se guardan como atributos del carrito y llegan al pedido.
      const regalo = q('[data-regalo]', raiz);
      if (regalo) {
        const check = q('[data-regalo-check]', regalo), campo = q('[data-regalo-campo]', regalo), texto = q('[data-regalo-texto]', regalo);
        const guardar = () => fetch(`${rutas.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Es un regalo': check.checked ? 'Sí' : '', 'Dedicatoria': check.checked && texto ? texto.value.trim() : '' } }) })
          .then((r) => { if (!r.ok) throw new Error(); })
          .catch(() => window.qapary.toast('No pudimos guardar la dedicatoria. Intenta de nuevo.', { tono: 'error' }));
        check.addEventListener('change', () => { campo.hidden = !check.checked; guardar(); if (check.checked && texto) texto.focus(); });
        if (texto) texto.addEventListener('change', guardar);
      }

      // Segunda pijama en la misma talla: se agrega con _origen (propiedad oculta) para medir qué suma cada palanca.
      qa('[data-agregar-sugerencia]', raiz).forEach((b) => b.addEventListener('click', async () => {
        if (b.disabled) return;
        const nombre = b.closest('[data-sugerencia]').querySelector('.sugerencia__nombre').textContent.trim();
        cargando(b, true);
        try {
          const data = await this.agregar(Number(b.dataset.agregarSugerencia), 1, { _origen: b.dataset.origen || 'drawer' });
          if (q('[data-carrito-pagina]') && b.closest('.carrito-pagina')) {
            if (!this.pintarPagina(data)) { location.reload(); return; }
            this.tras(`Agregaste ${nombre}.`);
            return;
          }
          this.reemplazar(data.sections['cart-drawer']);
          const d = q('[data-carrito-drawer]');
          const estado = q('[data-carrito-estado]', d);
          const subtotal = q('.carrito__subtotal .precio', d);
          if (estado) estado.textContent = `Agregaste ${nombre}. Subtotal ${subtotal ? subtotal.textContent.trim() : ''}.`;
          const titulo = q('[data-carrito-titulo]', d); if (titulo) titulo.focus();
        } catch (e) { window.qapary.toast(e.message, { tono: 'error' }); cargando(b, false); }
      }));

      // Empujón: agrega la variante con stock y refresca donde esté.
      qa('[data-agregar-rapido]', raiz).forEach((b) => b.addEventListener('click', async () => {
        if (b.disabled) return;
        cargando(b, true);
        try {
          const data = await this.agregar(Number(b.dataset.agregarRapido), 1, { _origen: 'empujon' });
          if (q('[data-carrito-pagina]')) { if (!this.pintarPagina(data)) { location.reload(); return; } this.tras('Agregado a tu carrito.'); return; }
          this.reemplazar(data.sections['cart-drawer']);
        } catch (e) { window.qapary.toast(e.message, { tono: 'error' }); cargando(b, false); }
      }));
    },
  };
  window.qapary.carrito = carrito;

  const drawer = q('[data-carrito-drawer]');
  if (drawer) carrito.enlazar(drawer);

  /* Agregar rápido en tarjetas ("Combina con"): elegir talla con stock y sumar sin entrar a la ficha. */
  let variantesEnCarrito = new Set();
  const elegirRapido = (caja, boton) => {
    if (!q('[data-rapido-talla]', caja)) return; // pijama sin talla: su único "Agregar" queda como viene del servidor
    qa('[data-rapido-talla]', caja).forEach((t) => t.setAttribute('aria-pressed', String(t === boton)));
    const agregarBtn = q('[data-rapido-agregar]', caja);
    if (!agregarBtn) return;
    // Si esa talla de esa pijama ya está en el carrito, la tarjeta lo dice y no suma una línea repetida
    // (la cantidad se cambia en el carrito). Otra talla de la misma pijama sí se puede sumar.
    if (boton && variantesEnCarrito.has(boton.dataset.variante)) {
      agregarBtn.disabled = true; delete agregarBtn.dataset.variante;
      agregarBtn.textContent = `Talla ${boton.dataset.rapidoTalla} ya en tu carrito`; agregarBtn.removeAttribute('aria-label');
      return;
    }
    if (boton) {
      agregarBtn.disabled = false; agregarBtn.dataset.variante = boton.dataset.variante;
      agregarBtn.textContent = `Agregar talla ${boton.dataset.rapidoTalla}`;
      agregarBtn.setAttribute('aria-label', `Agregar ${caja.dataset.producto}, talla ${boton.dataset.rapidoTalla}`);
    } else {
      agregarBtn.disabled = true; delete agregarBtn.dataset.variante;
      agregarBtn.textContent = 'Elige una talla'; agregarBtn.removeAttribute('aria-label');
    }
  };
  // Qué variantes hay en el carrito, según las líneas del drawer (se dibuja en todas las páginas y se redibuja al cambiar el carrito).
  const marcarEnCarrito = () => {
    variantesEnCarrito = new Set(qa('[data-carrito-drawer] [data-linea][data-variante]').map((l) => l.dataset.variante));
    qa('[data-rapido]').forEach((caja) => elegirRapido(caja, q('[data-rapido-talla][aria-pressed="true"]', caja)));
  };
  window.qapary.marcarEnCarrito = () => { marcarEnCarrito(); sincronizarRapido(); };
  // En la ficha, la talla ya elegida arriba queda marcada en las tarjetas que la tienen.
  const tallaFicha = () => { const i = q('[data-opcion-es-talla] input:checked'); return i ? i.value : ''; };
  const sincronizarRapido = () => {
    const talla = tallaFicha(); if (!talla) return;
    // Si la tarjeta no tiene esa talla, se respeta la que la compradora haya elegido a mano en ella.
    qa('[data-rapido]').forEach((caja) => {
      const chip = qa('[data-rapido-talla]', caja).find((t) => t.dataset.rapidoTalla === talla);
      if (chip) elegirRapido(caja, chip);
      else if (!caja.dataset.manual) elegirRapido(caja, null);
    });
  };
  document.addEventListener('change', (e) => { if (e.target.closest('[data-opcion-es-talla]')) sincronizarRapido(); });
  document.addEventListener('click', async (e) => {
    const chip = e.target.closest('[data-rapido-talla]');
    if (chip) { const caja = chip.closest('[data-rapido]'); caja.dataset.manual = '1'; elegirRapido(caja, chip); return; }
    const b = e.target.closest('[data-rapido-agregar]');
    if (!b || b.disabled || !b.dataset.variante) return;
    const caja = b.closest('[data-rapido]');
    cargando(b, true);
    try {
      const data = await carrito.agregar(Number(b.dataset.variante), 1, { _origen: caja.dataset.origen || 'combina' });
      if (caja.dataset.origen === 'carrito' && q('.carrito-pagina')) {
        if (!carrito.pintarPagina(data)) { location.reload(); return; }
        carrito.tras(`Agregaste ${caja.dataset.producto}.`);
        return;
      }
      carrito.reemplazar(data.sections['cart-drawer']);
      window.qapary.paneles.abrir('carrito', b);
    } catch (err) { window.qapary.toast(err.message, { tono: 'error' }); }
    finally {
      cargando(b, false);
      elegirRapido(caja, q('[data-rapido-talla][aria-pressed="true"]', caja)); // si esa talla quedó en el carrito, el botón vuelve a apagarse
    }
  });
  marcarEnCarrito();
  sincronizarRapido();
  window.qapary.sincronizarRapido = () => { marcarEnCarrito(); sincronizarRapido(); };

  /* Abrir el drawer desde el enlace del header (si hay JS) */
  qa('[data-carrito-enlace]').forEach((a) => a.addEventListener('click', (e) => {
    if (q('[data-carrito-pagina]')) return;
    e.preventDefault(); carrito.refrescar().then(() => window.qapary.paneles.abrir('carrito')).catch(() => { location.href = a.href; });
  }));

  /* Página del carrito */
  const pagina = q('[data-carrito-pagina]');
  if (pagina) carrito.enlazar(pagina);
})();
